import React, { ReactElement, ReactNode } from "react"
import TwoColumnRightPrimary from "../views/atoms/layouts/TwoColumnRightPrimary"
// eslint-disable-next-line no-restricted-imports -- FIXME: Usages of styled-components should be replaced with components from carotene-core or carotene-core-x. Please do not import styled-components after eslint rule added on 3/21/2025.
import styled from "styled-components"
import { GuidanceElement } from "#/lib/contentful/components/GuidanceElement"
import { Tile } from "#/lib/contentful/components/TileElement"
import { useResponsiveTalkToCarrotComponent } from "./hooks/useResponsiveTalkToCarrotComponent"
import { Box } from "@carrotfertility/carotene-core"

type TalkToCarrotTilePageProps = {
  guidance: ReactElement<typeof GuidanceElement>
  tiles: ReactElement<typeof Tile>[]
}

const TalkToCarrotStyledTilesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(265px, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: 24px;
`

const TalkToCarrotTilesWrapper = ({ children }: { children: ReactNode }) => (
  <TalkToCarrotStyledTilesWrapper>{children}</TalkToCarrotStyledTilesWrapper>
)

const TalkToCarrotTilePage = ({ guidance, tiles }: TalkToCarrotTilePageProps) => {
  const largeContent = (
    <TwoColumnRightPrimary
      secondaryContent={guidance}
      primaryContent={<TalkToCarrotTilesWrapper>{tiles}</TalkToCarrotTilesWrapper>}
    />
  )

  const mediumContent = (
    <>
      {guidance}
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xxxl })}>
        <TalkToCarrotTilesWrapper>{tiles}</TalkToCarrotTilesWrapper>
      </Box>
    </>
  )

  const smallContent = (
    <>
      {guidance}
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xl })}>
        <TalkToCarrotTilesWrapper>{tiles}</TalkToCarrotTilesWrapper>
      </Box>
    </>
  )

  const responsiveContent = useResponsiveTalkToCarrotComponent(smallContent, mediumContent, largeContent)
  return responsiveContent || <></>
}

export default TalkToCarrotTilePage
